<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <el-row>
      <el-col :span="4" class="item-label"><span class="hl-red">业务区域</span></el-col>
      <el-col :span="8">
        <el-input v-model="biz_relation_info.business_area" @input="inputBusinessArea" disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-select v-model="businessAreaValue" placeholder="请选择业务区域" class="w-50" @change="handleSelectedBusinessArea" multiple>
          <el-option v-for="(item, index) in businessAreaOptions" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">业务推荐人</el-col>
      <el-col :span="8">
        <el-input v-model="biz_relation_info.referrer" @input="inputReferrer" disabled></el-input>
      </el-col>
      <el-col :span="12">
        <el-select placeholder="输入关键字后搜索并选择，或直接输入空格" filterable remote reserve-keyword multiple
                   :remote-method="remoteSearchReferences" v-model="referencesValue" class="w-50" @change="handleSelectedReferences">
          <el-option v-for="item in referencesOptions" :key="item.id" :label="item.first_name" :value="item.first_name"></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">业务来源</el-col>
      <el-col :span="8">
        <el-input v-model="biz_relation_info.business_source" @input="inputBusinessSource" :disabled="disabled"></el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model="biz_relation_info.business_source" @input="inputBusinessSource" placeholder="请输入" class="w-50"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4" class="item-label">托管代理人</el-col>
      <el-col :span="8">
        <el-input v-model="biz_relation_info.escrow_agent" @input="inputEscrowAgent" ></el-input>
      </el-col>
      <el-col :span="12">
        <el-select placeholder="输入关键字后搜索并选择，或直接输入空格" filterable remote reserve-keyword
                   :remote-method="remoteSearchEscrowAgent" v-model="escrowAgentValue" class="w-50" @change="handleSelectedEscrowAgent">
          <el-option v-for="item in escrowAgentOptions" :key="item.id" :label="item.first_name" :value="item.first_name"></el-option>
        </el-select>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { fetchUserNameList } from "@/api/user";
import { fetchGroupNameList } from "@/api/group";
export default {
  name: 'biz-relation-info-input',
  props: {
    is_disabled:{
      default:true
    },
    business_area:{
      default:''
    },
    business_source:{
      default:''
    },
    referrer:{
      default:''
    },
    escrow_agent:{
      default:''
    },
    group_ids:{
      default:()=>[]
    },
    group_names:{
      default:()=>[]
    },
  },
  data() {
    return {
      dialogVisible: false,
      disabled: this.is_disabled,
      // 推荐人选项
      referencesOptions: [],
      referencesValue: null,

      // 业务区域选项
      businessAreaOptions: [],
      businessAreaValue: null,

      // 托管代理人选项
      escrowAgentOptions: [],
      escrowAgentValue: null,

      biz_relation_info: {
        business_area: this.business_area,
        business_source: this.business_source,
        referrer: this.referrer,
        escrow_agent: this.escrow_agent,
        group_ids: this.group_ids,
        group_names: this.group_names,
      },
    }
  },
  watch: {
    'is_disabled': function (val){
      this.disabled = val
    },
    'business_area': function(val){
      this.biz_relation_info.business_area = val
    },
    'business_source': function(val){
      this.biz_relation_info.business_source = val
    },
    'referrer': function(val){
      this.biz_relation_info.referrer = val
    },
    'escrow_agent': function(val){
      this.biz_relation_info.escrow_agent = val
    },
    'group_ids': function(val){
      this.biz_relation_info.group_ids = val
    },
    'group_names': function(val){
      this.biz_relation_info.group_names = val
    },
  },
  methods:{
    showDialog(){
      this.dialogVisible = true
    },
    loadData(){
      let p = []
      p.push(fetchGroupNameList({}))
      Promise.all(p).then(resp => {
        // 获取业务区域选项
        let tempBusinessAreaOptions = Object.assign([], resp[0])
        this.businessAreaOptions = []
        for (let o of tempBusinessAreaOptions){
          this.businessAreaOptions.push({
            "value":o.id,
            "label":o.name,
          })
        }
      })
    },

    // 搜索并获取推荐人
    remoteSearchReferences(search) {
      if (search !== '') {
        // this.loading = true
        fetchUserNameList({search: search})
            .then(res => {
              this.referencesOptions = Object.assign([], res)
              // this.loading = false
            })
            .catch(error => {
              // this.loading = false
              this.$error_message(error)
            })
      } else {
        this.referencesOptions = []
      }
    },
    // 处理所选择的推荐人
    handleSelectedReferences(value){
      let selectedItem = ''
      if (value.length > 0) {
        selectedItem = value.join("、")
      }
      this.inputReferrer(selectedItem)

      // let selectedItem = this.referencesOptions.find(item => {
      //   return(item.first_name === value)
      // })
      // if(selectedItem) {
      //   this.inputReferrer(selectedItem.first_name)
      // } else {
      //   this.$message.error("选择出错")
      // }
    },
    // 搜索并获取托管代理人
    remoteSearchEscrowAgent(search) {
      if (search !== '') {
        // this.loading = true
        fetchUserNameList({search: search})
            .then(res => {
              this.escrowAgentOptions = Object.assign([], res)
              // this.loading = false
            })
            .catch(error => {
              // this.loading = false
              this.$error_message(error)
            })
      } else {
        this.escrowAgentOptions = []
      }
    },
    // 处理所选择的托管代理人
    handleSelectedEscrowAgent(value){
      let selectedItem = this.escrowAgentOptions.find(item => {
        return(item.first_name === value)
      })
      if(selectedItem) {
        this.inputEscrowAgent(selectedItem.first_name)
      } else {
        this.$message.error("选择出错")
      }
    },

    handleSelectedBusinessArea(areas){
      if (areas instanceof Array){
        this.biz_relation_info.group_ids = []
        this.biz_relation_info.group_names = []
        for (let i=0; i<areas.length; i++){
          for (let businessArea of this.businessAreaOptions){
            if(businessArea.value === areas[i]){
              this.biz_relation_info.group_ids.push(businessArea.value)
              this.biz_relation_info.group_names.push(businessArea.label)
            }
          }
        }
        this.inputBusinessArea(this.biz_relation_info.group_names.join(','))
      }
    },
    emitUpdate(){
      this.$emit('change', this.biz_relation_info)
    },
    inputBusinessArea(val){
      this.biz_relation_info.business_area = val
      this.emitUpdate()
    },
    inputBusinessSource(val){
      this.biz_relation_info.business_source = val
      this.emitUpdate()
    },
    inputReferrer(val){
      this.biz_relation_info.referrer = val
      this.emitUpdate()
    },
    inputEscrowAgent(val){
      this.biz_relation_info.escrow_agent = val
      this.emitUpdate()
    },
    validate(){
      let result = []
      if(this.biz_relation_info.business_area === '' || this.biz_relation_info.business_area === null) result.push('业务区域')
      return result
    }
  },
  created() {
    this.loadData()
  }
}

</script>

<style scoped>
.item-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.hl-red {
  color: red;
}

>>> .el-dialog {
  width:96%;
}
</style>
